export default "__VITE_ASSET__srOz51cD__"